import React, { useState } from "react";
import "../App.css";
import { Link, Outlet } from "react-router-dom";
import config from "../config";

import { useNavigate } from "react-router-dom";

function Hero({ children }) {

  const navigate = useNavigate();

  const [activateAdding, setActivateAdding] = useState(false)

  const sendMail = async (e) => {
    e.preventDefault()
    if (!e.target[1].value.includes("@")) {
      alert("Gib wenigstens eine echte E-Mail an")
      return
    }
    const response = await fetch(`${config.BaseUrl}/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: e.target[0].value,
        email: e.target[1].value,
        message: e.target[2].value,
      }),
    });
    alert("email gesendet")
  }

  return (
    <div className="App">
      {/* Header */}
      <header className="header" style={{ display: "none" }}>
        <div className="container">
          <h1 className="logo">Dönersonntag</h1>
          <nav className="nav">
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="hero">
        <div className="hero-headline">
          <h2>Dönersonntag - unsere Expertenbewertung</h2>
        </div>
      </section>

      {/* Leistungen */}
      <section id="leistungen" className="leistungen container">
        <Outlet />
        {activateAdding &&
          <Link to="/add" className="hero-button">
            ➕ Hinzufügen
          </Link>
        }

      </section>
      <hr></hr>
      {/* Über uns */}
      <section id="ueber" className="ueber">
        <div className="container">
          <h3>Über uns</h3>
          <p>
            Wir sind zwei beste Freunde – verbunden durch ein festes Ritual: Jeden Sonntag suchen wir einen neuen Dönerladen auf, probieren den Döner und teilen anschließend unsere ehrliche Meinung. Aus Spaß wurde Tradition, und aus der Tradition dieser Blog.

            Hier findet ihr unsere Bewertungen, Eindrücke und vielleicht auch die ein oder andere Empfehlung für euren nächsten Döner-Sonntag. 🌯❤️
          </p>
        </div>
      </section>
      {/* Kontakt */}
      <section id="kontakt" className="kontakt container">
        <h3>Döner vorschlagen</h3>
        <form onSubmit={sendMail}>
          <input type="text" placeholder="Ihr Name" />
          <input type="email" placeholder="Ihre E-Mail" />
          <textarea placeholder="Ihre Nachricht"></textarea>
          <button type="submit">Senden</button>
          <a
            href="https://www.döner-sonntag.de/datenschutz"
            onClick={(e) => {
              e.preventDefault();
              navigate("/datenschutz");
            }}
          >
            * Datenschutz
          </a>
        </form>
      </section>

      {/* Footer */}
      <footer className="footer" onDoubleClick={() => { setActivateAdding(true) }}>
        <p>Nur zwei Dönerentusiasten</p>
        <a
          href="https://www.döner-sonntag.de/impressum"
          onClick={(e) => {
            e.preventDefault(); // verhindert echten Seitenwechsel
            navigate("/impressum");
          }}
        >
          impressum
        </a>
      </footer>
    </div>
  );
}

export default Hero;
